import axios from 'axios'
import { The } from 'helpers/generalHelpers'
import { HTTP } from 'types'
import { APIURL, config, getCurrentWorkspace } from './_utils'

// #region FORM ROWS

const workspace = getCurrentWorkspace()

export const responses = {
  create: (formData, formSlug) =>
    The(
      axios.post(
        `${APIURL}/v4/forms/${formSlug}/rows/`,
        formData,
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),

  getOne: (submitSlug) =>
    axios.get(`${APIURL}/v4/rows/${submitSlug}/`, config({ workspace })),

  getAll: (formSlug, params = {}) =>
    The(
      axios.get(
        `${APIURL}/v4/forms/${formSlug}/rows/`,
        config({ params, workspace })
      )
    ),
  update: (submitSlug, formData) =>
    The(
      axios.patch(
        `${APIURL}/v4/rows/${submitSlug}/`,
        formData,
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),
  delete: (submitSlug) =>
    The(
      axios.delete(`${APIURL}/v4/rows/${submitSlug}/`, config({ workspace }))
    ),

  deleteMultiple: (formSlug, rowSlugs) =>
    The(
      axios.post(
        `${APIURL}/v4/forms/${formSlug}/rows/bulk-delete/`,
        { slugs_list: rowSlugs },
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),
}

// #endregion FORM ROWS
